export class stockBalanceReq{
    area?:string;
    productSKU?:string;
    redemChannellist?:string[];
}